import { HISTORY_INFO_CHANGE_TYPE_CODE } from '@hems/util/src/constant';
// eslint-disable-next-line import/prefer-default-export
export const useJsonFileConverter = () => {
    const findLatestReplacement = (startDeviceId, microInverterActivityList) => {
        const device = microInverterActivityList.find((activityInfo) => activityInfo.previousMicroInverterId === startDeviceId &&
            (activityInfo.activity === HISTORY_INFO_CHANGE_TYPE_CODE.REPLACE_MI ||
                activityInfo.activity === HISTORY_INFO_CHANGE_TYPE_CODE.REPLACE));
        if (!device) {
            return startDeviceId;
        }
        return findLatestReplacement(device.microInverterId, microInverterActivityList);
    };
    const findMappedSerial = (json) => {
        if (!json)
            return [];
        const regex = /"qserial":"(.*?)"/g;
        let matches;
        const results = [];
        while ((matches = regex.exec(json)) !== null) {
            if (matches[1] !== '') {
                results.push(matches[1]);
            }
        }
        return results;
    };
    const getQSerialRegex = (targetSerial) => new RegExp(`"qserial":"${targetSerial}"`, 'g');
    const getMapperJsonReplaceSerial = (currentJson, targetSerial, replaceSerial) => currentJson?.replace(getQSerialRegex(targetSerial), `"qserial":"${replaceSerial}"`);
    const getMapperJsonRemoveSerial = (currentJson, targetSerial) => currentJson?.replace(getQSerialRegex(targetSerial), '"qserial":""');
    /** replace된 Id가 있고 최신 MI List에 있는 지 체크 */
    const isReplacedDevice = (replaceDeviceId, targetMicroInverterId, recentMicroinverterList) => replaceDeviceId !== targetMicroInverterId &&
        recentMicroinverterList.some((microInverterId) => microInverterId === replaceDeviceId);
    const getNewCanvasJsonFile = (currentJson, targetMicroInverterId, microInverterActivityList, recentMicroinverterList) => {
        const replaceDeviceId = findLatestReplacement(targetMicroInverterId, microInverterActivityList);
        if (isReplacedDevice(replaceDeviceId, targetMicroInverterId, recentMicroinverterList)) {
            return getMapperJsonReplaceSerial(currentJson, targetMicroInverterId, replaceDeviceId);
        }
        return getMapperJsonRemoveSerial(currentJson, targetMicroInverterId);
    };
    const convertJsonFileForMicroInverterUpdateActivity = (currentJson, recentMicroinverterList, targetMicroInverterIdList, microInverterActivityList) => {
        let newJson = currentJson;
        targetMicroInverterIdList.forEach((microInverterId) => {
            newJson = getNewCanvasJsonFile(newJson, microInverterId, microInverterActivityList, recentMicroinverterList);
        });
        return newJson;
    };
    return { convertJsonFileForMicroInverterUpdateActivity, findMappedSerial };
};
